// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__NNmka","vLegacy":"SelectSecondary_vLegacy__aKdRv","error":"SelectSecondary_error__3aai2","disabled":"SelectSecondary_disabled__1BFDo"};